import { DataTable } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetch } from "../../lib/fetch";
import { Enquiry } from "./model";
import { enquiriesColumns } from "./enquiriesColumns";

type SearchPagination = {
  total: number;
  pagination: {
    page: number;
    pageSize: number;
  };
};

type EnquiriesData = {
  data: Enquiry[];
} & SearchPagination;

export function EnquiriesTable({ search, status, charterType, withoutOffer }: { search?: string; status?: string; charterType?: string; withoutOffer?: boolean }) {
  const [loading, setLoading] = useState(false);
  const [enquiries, setEnquiries] = useState<EnquiriesData>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 10 },
  });
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  // Reset to the first page whenever the filters change.
  useEffect(() => {
    setPage(1);
  }, [search, status, charterType, withoutOffer]);

  useEffect(() => {
    // Ignore a stale in-flight response (e.g. page reset races a search change)
    // so it can't overwrite the current results.
    let ignore = false;
    setLoading(true);
    const params = new URLSearchParams({ page: String(page), pageSize: "10", sort: "DESC" });
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    if (charterType) params.set("charterType", charterType);
    if (withoutOffer) params.set("withoutOffer", "true");
    fetch<EnquiriesData>(`/api/enquiries?${params.toString()}`)
      .then((data) => {
        if (!ignore) setEnquiries(data);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [page, search, status, charterType, withoutOffer]);

  return (
    <div className="rounded-md bg-white border overflow-hidden">
      <DataTable
        columns={enquiriesColumns}
        data={enquiries.data}
        onRowClick={(r) => navigate(`/enquiries/${r.id}`)}
        isLoading={loading}
        pagination={{
          pagination: {
            page: +enquiries.pagination.page,
            pageSize: +enquiries.pagination.pageSize,
          },
          total: enquiries.total,
        }}
        onPageClick={(p) => setPage(p)}
      />
    </div>
  );
}
